import { apiClient } from "./apiClient";

export const eventApi = {
  eventRegister: (payload) => {
    return apiClient.post(
      `${process.env.REACT_APP_EVENTS_PATH}/${payload.eventId}/records`,
      { userId: payload.userId },
    );
  },

  getAllEvents: ({ page = 1, pageSize = 15, signal } = {}) => {
    const params = new URLSearchParams({
      page: String(page),
      pageSize: String(pageSize),
    });
    return apiClient.get(
      `${process.env.REACT_APP_EVENTS_PATH}?${params.toString()}`,
      { signal },
    );
  },

  getEventRecords: ({
    eventId,
    page = 1,
    pageSize = 15,
    payment,
    signal,
  } = {}) => {
    const params = new URLSearchParams({
      page: String(page),
      pageSize: String(pageSize),
    });

    if (payment !== "" && payment !== undefined && payment !== null) {
      params.append("payment", String(payment));
    }

    return apiClient.get(
      `${process.env.REACT_APP_EVENTS_PATH}/${eventId}/records?${params.toString()}`,
      { signal },
    );
  },
};
